const UserNotificationStatus = {
  New: 'New',
  Viewed: 'Viewed',
  Clicked: 'Clicked',
  Dismissed: 'Dismissed',
} as const;

type UserNotificationStatus = (typeof UserNotificationStatus)[keyof typeof UserNotificationStatus];

export { UserNotificationStatus };
